module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/urbania_adondevivir.dcd0d753.svg";